import { defineMessages } from 'react-intl';

export const messages: {
    switchTo: {
        id: string;
        defaultMessage: string;
        description: string;
    }; loggedInViewLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; loggedOutViewLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; loggedInAriaLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; loggedOutAriaLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	switchTo: {
		id: 'twg-microsite.switchViewBanner.switchTo',
		defaultMessage: "[This exists for dev only - customers won't see this] Switch to",
		description: 'Prompt text in the view-switching banner',
	},
	loggedInViewLabel: {
		id: 'twg-microsite.switchViewBanner.loggedInViewLabel',
		defaultMessage: 'Logged In View',
		description: 'Label for the button that switches to the logged-in view',
	},
	loggedOutViewLabel: {
		id: 'twg-microsite.switchViewBanner.loggedOutViewLabel',
		defaultMessage: 'Logged Out View',
		description: 'Label for the button that switches to the logged-out view',
	},
	loggedInAriaLabel: {
		id: 'twg-microsite.switchViewBanner.loggedInAriaLabel',
		defaultMessage: 'Logged in',
		description:
			'Accessible label for the switch-view button when currently in the logged-out view',
	},
	loggedOutAriaLabel: {
		id: 'twg-microsite.switchViewBanner.loggedOutAriaLabel',
		defaultMessage: 'Logged out',
		description: 'Accessible label for the switch-view button when currently in the logged-in view',
	},
});
